module.exports = __webpack_public_path__ + "static/portfolio-img2-3f85a9c11912768ba6ac3dd1bb86c9d9.jpg";